import InitialLoadingPage from './InitialLoadingPage';
import PageChunkLoadingPage from './PageChunkLoadingPage';

export { InitialLoadingPage, PageChunkLoadingPage };
export default PageChunkLoadingPage;
